/* ShockSims cart drawer accessories

   WHAT CHANGED AND WHY

   1. The Add button never came back.
      On success the button was left disabled with the text "..." forever.
      It only looked fine because Horizon usually replaces the drawer DOM
      afterwards. When it did not, the button was stuck. It now restores.

   2. itemCount was hardcoded to 1.
      The cart:update event reported a cart of one item no matter what was
      actually in the cart, so anything downstream reading that number got a
      wrong value. The real count now comes from /cart.js.

   3. The MutationObserver watched a node that could be replaced.
      It observed the cart-drawer-component element captured at page load.
      If Horizon replaced that element rather than its children, the observer
      was left watching a detached node and silently stopped rebinding. The
      observer is gone entirely: one delegated listener on document handles
      every button, present or future, with no rebinding needed.

   4. Failures were silent to the shopper.
      An error only reset the button. It now says so.
*/

(function () {
  'use strict';

  if (window.__ssCartAccessoriesLoaded) return;
  window.__ssCartAccessoriesLoaded = true;

  var BTN_SELECTOR = '.cart-drawer-accessories__add-btn';
  var DEFAULT_LABEL = 'Add';

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function resetButton(btn, label) {
    btn.disabled = false;
    btn.textContent = label || DEFAULT_LABEL;
  }

  function announceCartUpdate() {
    // Read the real cart so the event carries an accurate item count.
    return fetch(rootUrl() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : undefined,
                source: 'product-form-component'
              }
            }
          })
        );
      });
  }

  function handleAccessoryClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest(BTN_SELECTOR) : null;
    if (!btn) return;
    if (btn.disabled) return;

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var originalLabel = btn.textContent.trim() || DEFAULT_LABEL;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed with status ' + response.status);
        return response.json();
      })
      .then(function () {
        return announceCartUpdate();
      })
      .then(function () {
        // The drawer usually re-renders and replaces this button. If it does
        // not, leave the shopper with a button that works again.
        btn.textContent = 'Added';
        setTimeout(function () {
          if (btn.isConnected) resetButton(btn, originalLabel);
        }, 1200);
      })
      .catch(function (err) {
        console.error('Cart accessory add error:', err);
        btn.textContent = 'Try again';
        setTimeout(function () {
          if (btn.isConnected) resetButton(btn, originalLabel);
        }, 1600);
        btn.disabled = false;
      });
  }

  // One delegated listener. Survives every drawer re-render with no rebinding.
  document.addEventListener('click', handleAccessoryClick);
})();